<template>
    <section class="c-login-page c-stretch-page u-flex-set u-flex--content-center u-flex--align-items-center">
        <div>
            <form @submit.prevent="submitForm" class="c-form c-form--horizontal">

                <div class="o-page-row--medium u-text-align-center"><router-link to="/"><img class="[ c-logo ]" src="@/assets/images/logo.png" width="170px" height="79px"/></router-link></div>

                <h1 class="u-text-align-center">{{ $t('customer.account.forgot.title') }}</h1>
                <p>{{ $t('customer.account.forgot.description') }}</p>

                <v-form-row>
                    <v-input v-model="Email" name="email" type="email" :fluid="true" :error="Validate.Email" :readonly="SendDisabled">
                        <slot slot="label">{{ $t('customer.account.edit.form.personal.email.label') }}</slot>
                    </v-input>
                    <div v-if="InvalidEmail" class="u-color-error-base" style="padding-left: 247px; padding-top: 5px;">
                        {{ $t('customer.account.forgot.invalidEmail') }}
                    </div>
                </v-form-row>

                <v-form-row>
                    <div class="c-form-item" style="padding-left: 247px">
                        <button :disabled="SendDisabled" class="c-button c-button--alpha">{{ $t('customer.account.register.submit') }}</button>
                    </div>
                </v-form-row>
            </form>
        </div>
        <notifications group="global" position="bottom right">
                <template slot="body" slot-scope="props">
                    <div class="c-notification" :class="props.item.type">
                        <svgicon name="check" v-if="props.item.type === 'success'"></svgicon>
                        <div>
                            <p class="c-notification__title">{{props.item.title}}</p>
                            <div class="c-notification__text" v-html="props.item.text"></div>
                        </div>
                        <button type="button" class="c-notification__close c-button--reset c-button--icon u-flex--push-left" @click="props.close">
                            <svgicon name="close"></svgicon>
                        </button>
                    </div>
                </template>
            </notifications>
    </section>
</template>

<script>

    // Forms
    import debounce from 'lodash/debounce'
    import VInput from '@/components/form/Input'
    import VFormRow from '@/components/form/Row'

    export default {
        components: {
            VInput,
            VFormRow,
        },
        data() {
            return {
                Email: null,
                InvalidEmail: false,
                SendDisabled: true,
                Validate: {}
            }
        },
        watch: {
            Email: debounce(function() {
                this.SendDisabled = !this.validEmail(this.Email);
                this.InvalidEmail = !this.validEmail(this.Email);
            }, 500)
        },
        methods: {
            validateForm(response){
                let errors = response.data.ModelState;
                // Get error data from server, and transform to vue data
                Object.keys(errors).forEach(function(key) {
                    key = key.replace('model.', '');
                    errors[key] = errors['model.'+key][0];
                    delete errors['model.'+key];
                });
                this.Validate = errors;
            },
            validEmail(email) {
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },
            submitForm(e) {
                this.SendDisabled = true;

                this.$store.dispatch('forgotPassword', {
                    Email: this.Email
                }).then((response) => {
                    if (response.status > 300) {
                        this.validateForm(response);
                        this.SendDisabled = false;
                    } else {
                        this.SendDisabled = false;
                        this.$notify({
                            group: 'global',
                            title: this.$t('customer.account.forgot.email_sent'),
                            type: 'success',
                            duration: 5000
                        });
                    }
                });
                e.preventDefault();
            }
        }
    }
</script>

<style lang="scss">
    @import "~@/assets/scss/private";

    .c-login-page {
        background-color: white;
    }

    .c-login-block {
        width: 100%;
        max-width: em(400px);
    }
</style>

<style lang="scss" scoped>
    @import "~@/assets/scss/private";

    .c-stretch-page {
        height: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/views/common/PasswordForgot.vue